import React from "react";
import "./Dropdown.css";
import { FaChevronDown } from "react-icons/fa";

const Dropdown = ({
  options = [],
  placeholder,
  onChange,
  value,
  style,
  // Yeni prop: addWorkspaceOption, örneğin { label: "Add Workspace", onClick: () => {} }
  addWorkspaceOption,
}) => {
  // Eğer addWorkspaceOption varsa, options listesinin başına ekliyoruz
  const modifiedOptions = addWorkspaceOption
    ? [
      ...options,
      {
        value: "add-workspace", // özel value
        label: ` ${addWorkspaceOption.label || "Add Workspace"}`,
      },
    ]
    : options;

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    // Eğer "add-workspace" seçildiyse, ilgili callback'i çağır
    if (selectedValue === "add-workspace" && addWorkspaceOption) {
      addWorkspaceOption.onClick && addWorkspaceOption.onClick();
      // İşlem yapıldıktan sonra seçimi iptal etmek için
      return;
    }
    onChange(e);
  };

  return (
    <div className="custom-select-container" style={style}>
      <select value={value} onChange={handleSelectChange} defaultValue="">
        <option value="" disabled>
          {placeholder}
        </option>
        {modifiedOptions.map((option, index) => (
          <option
            key={index}
            value={option.value}
            className={
              option.value === "add-workspace" ? "dropdown-add-option" : ""
            }
          >
            {option.label}
          </option>
        ))}
      </select>
      <FaChevronDown className="dropdown-icon" />
    </div>
  );
};

export default Dropdown;
